var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 29,
    viewBox: "0 0 161 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9672 0L16.9417 9.14801H26.5671L18.78 14.8018L21.7544 23.9498L13.9672 18.296L6.18006 23.9498L9.15449 14.8018L1.36732 9.14801H10.9928L13.9672 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.772 2.52148L49.7465 11.6695H59.3719L51.5848 17.3233L54.5592 26.4713L46.772 20.8175L38.9849 26.4713L41.9593 17.3233L34.1721 11.6695H43.7976L46.772 2.52148Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8402 2.52148L83.8146 11.6695H93.4401L85.6529 17.3233L88.6273 26.4713L80.8402 20.8175L73.053 26.4713L76.0274 17.3233L68.2402 11.6695H77.8657L80.8402 2.52148Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.645 2.52148L116.619 11.6695H126.245L118.458 17.3233L121.432 26.4713L113.645 20.8175L105.858 26.4713L108.832 17.3233L101.045 11.6695H110.671L113.645 2.52148Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147.712 2.52148L150.687 11.6695H160.312L152.525 17.3233L155.499 26.4713L147.712 20.8175L139.925 26.4713L142.899 17.3233L135.112 11.6695H144.738L147.712 2.52148Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.2ead50c93437c8809ea9332a3f42a793.svg";
export { ForwardRef as ReactComponent };